import React from 'react'

import { useQuery } from '@apollo/client'
import query from './query.graphql'

const withQuery = WrappedComponent => {
  return props => {
    const {
      onQueryError, // via withQueryResults
      mergeAccountForm // via redux actions
    } = props

    const handleCompleted = data => {
      if (data && data.accountDefaults) {
        mergeAccountForm(data.accountDefaults)
      }
    }

    // react hooks
    const { loading, data } = useQuery(query, {
      onError: onQueryError,
      onCompleted: handleCompleted
    })

    // GraphQL data
    const { viewer: account, states, countries, text } = data || {}

    return (
      <WrappedComponent
        account={account}
        queryLoading={loading}
        states={states}
        countries={countries}
        text={text}
        {...props}
      />
    )
  }
}

export default withQuery
